/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useParams } from 'react-router-dom';
import { Row } from 'antd';

import { Form } from '@organisms';
import { Button } from '@atoms';

// TODO: StasY has same component. Merge into 1 and reuse
const AddSelectEntity = ({ onAdd, label, addText, select: Select, clearAfterAdd = true, isTypeFilter = false }) => {
  const [selectedEntity, setSelectedEntity] = React.useState();
  const { locale } = useParams();

  const handleAdd = () => {
    onAdd(selectedEntity);
    if (clearAfterAdd) {
      setSelectedEntity(undefined);
    }
  };

  return (
    <>
      <Form.Item label={label} style={{ marginBottom: 15 }}>
        <Select
          value={selectedEntity}
          onChange={setSelectedEntity}
          queryVariables={{ language: locale }}
          style={{ width: '100%' }}
          isTypeFilter={isTypeFilter}
        />
      </Form.Item>
      <Row style={{ marginBottom: 50 }}>
        <Button disabled={!selectedEntity} type="customBlue" onClick={handleAdd}>
          {addText}
        </Button>
      </Row>
    </>
  );
};

export default AddSelectEntity;
